import React, { useState, useEffect } from 'react';
import TituloAdmin from '@components/TituloAdmin';
import BotonBuscar from '@components/BotonBuscar';
import Boton from '@components/Boton';
import LoadingOverlay from '@components/LoadingOverlay';
import LabelCarga from '@components/LabelCarga';
import '@styles/modernTable.css';
import Notify from '@components/Notify';
import Label from '@components/Label';

import { tablaEstylos, tablaTheadEstylos, trStyle, thStyle } from '@styles/tablaEstylos';
import { colors } from '@styles/colors';
import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorAdminStyle } from '@styles/cajaContenedorAdmin';
import { selectStyle } from '@styles/selecsEstylos';

import { getBoldResponsesApi } from '@api/wp/recibos/recibosApi';

function RPagos() {
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const [recibos, setRecibos] = useState([]);
  const [fechaInicio, setFechaInicio] = useState(new Date().toISOString().split('T')[0]);
  const [fechaFin, setFechaFin] = useState(new Date().toISOString().split('T')[0]);
  const [notify, setNotify] = useState({ open: false, message: '', type: 'success' });
  const [haConsultado, setHaConsultado] = useState(false);
  const [filtroTexto, setFiltroTexto] = useState('');

  const recibosFiltrados = recibos.filter(r => {
    if (!filtroTexto) return true;
    const termino = filtroTexto.toLowerCase();
    const documento = String(r?.numero_documento || r?.id_paciente || '').toLowerCase();
    const nombreCompleto = `${r?.first_name || ''} ${r?.second_name || ''} ${r?.first_surname || ''} ${r?.second_surname || ''}`.toLowerCase();
    return documento.includes(termino) || nombreCompleto.includes(termino);
  });

  const handleConsultar = async () => {
    if (!fechaInicio || !fechaFin) {
      setNotify({ open: true, message: 'Por favor seleccione ambas fechas', type: 'warning' });
      return;
    }
    try {
      setCargando(true);
      setError('');
      // No mandamos id_paciente para que traiga todos según el rango de fechas
      const response = await getBoldResponsesApi({ fechaInicio, fechaFin });
      setHaConsultado(true);
      if (response.statusCode === 200 && response.result) {
        setRecibos(response.result);
        if (response.result.length === 0) {
          setNotify({ open: true, message: 'No se encontraron pagos en ese rango de fechas', type: 'info' });
        }
      } else {
        setError('No se pudieron cargar los pagos');
      }
    } catch (e) {
      console.error('Error cargando pagos Bold:', e);
      setError('Error al cargar los recibos de pago');
    } finally {
      setCargando(false);
    }
  };

  const descargarExcel = () => {
    if (!recibosFiltrados.length) return;
    try {
      const headers = ['Documento', 'Paciente', 'Celular', 'Dirección', 'Fecha de pago', 'Servicio', 'Cita ID', 'Valor', 'Pasarela', 'Transacción', 'Estado'];
      const filas = recibosFiltrados.map(r => [
        r?.numero_documento || r?.id_paciente || '',
        `${r?.first_name || ''} ${r?.second_name || ''} ${r?.first_surname || ''} ${r?.second_surname || ''}`.trim(),
        r?.cellphone || '',
        r?.address || '',
        r?.fecha ?? '',
        r?.nombre_espe ?? '',
        r?.CitaID ?? '',
        r?.valor ? Number(r.valor) : 0,
        'BOLD',
        r?.idBold ?? '',
        r?.estado ?? ''
      ]);

      const sep = ';';
      const esc = (val) => `"${String(val || '').replace(/"/g, '""')}"`;
      let contenido = '\uFEFF' + headers.map(esc).join(sep) + '\r\n';
      filas.forEach(f => contenido += f.map(esc).join(sep) + '\r\n');

      const blob = new Blob([contenido], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Pagos_${fechaInicio}_al_${fechaFin}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (e) {
      console.error('Error exportando', e);
    }
  };

  return (
    <div id="cajaPrincipal" style={cajaPrincipalStyle}>
      <LoadingOverlay visible={cargando} />
      <Notify open={notify.open} message={notify.message} type={notify.type} onClose={() => setNotify({ ...notify, open: false })} />
      
      <TituloAdmin 
        titulo="Consultas de Pagos" 
        imagen_titulo="extras"
        subtitulo="Consultar historial de pagos por rango de fechas" 
      />

      <div style={cajaContenedorAdminStyle}>
        {/* Fila 1: Fechas y Botón de Consulta */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'stretch',
            columnGap: '7vh',
            rowGap: '2.5vh',
            marginBottom: '2vh',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 'min(100%, 28vh)' }}>
            <Label>Buscar Cédula/Paciente:</Label>
            <input
              type="text"
              placeholder="Digite buscar..."
              value={filtroTexto}
              onChange={(e) => setFiltroTexto(e.target.value)}
              style={{ ...selectStyle, marginTop: 'auto' }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Label>Fecha Inicio:</Label>
            <input
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              style={{ ...selectStyle, marginTop: 'auto' }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Label>Fecha Fin:</Label>
            <input
              type="date"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
              style={{ ...selectStyle, marginTop: 'auto' }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '1vh' }}>
            <Label aria-hidden style={{ visibility: 'hidden', pointerEvents: 'none' }}>
              &nbsp;
            </Label>
            <BotonBuscar
              onClick={handleConsultar}
              disabled={cargando}
              titulo="Consultar pagos en el rango de fechas"
              varianteFiltros
            />
          </div>
        </div>
        {/* Tabla de recibos */}
        <div className="modern-table-container">
          {cargando ? (
            <div style={{ padding: '4vh' }}>
              <LabelCarga nombre="pagos" />
            </div>
          ) : recibosFiltrados.length > 0 ? (
            <table className="modern-table">
              <thead>
                <tr>
                  <th>Documento</th>
                  <th>Paciente</th>
                  <th>Celular</th>
                  <th>Dirección</th>
                  <th>Fecha de pago</th>                    
                  <th>Servicio</th>
                  <th>Cita Id</th>                    
                  <th style={{ textAlign: 'right' }}>Valor</th>
                  <th>Transacción</th>
                  <th>Estado</th>                    
                </tr>
              </thead>
              <tbody>
                {recibosFiltrados.map((r, idx) => (
                  <tr key={r?.id ?? idx}>
                    <td style={{ fontWeight: 500 }}>{r?.numero_documento || r?.id_paciente || ''}</td>
                    <td>{`${r?.first_name || ''} ${r?.second_name || ''} ${r?.first_surname || ''} ${r?.second_surname || ''}`.trim()}</td>
                    <td>{r?.cellphone || ''}</td>
                    <td>{r?.address || ''}</td>
                    <td>{r?.fecha ?? ''}</td>
                    <td>{r?.nombre_espe ?? ''}</td>
                    <td>{r?.CitaID ?? ''}</td>                        
                    <td style={{ textAlign: 'right', fontWeight: 600, color: '#1a202c' }}>
                      $ {r?.valor ? Number(r.valor).toLocaleString('es-CO') : '0'}
                    </td>
                    <td style={{ fontFamily: 'monospace', fontSize: '1.4vh', color: '#718096' }}>{r?.idBold ?? ''}</td>
                    <td>
                      <span className={`status-badge ${r?.estado?.toLowerCase() === 'aprobado' ? 'status-aprobado' : 'status-rechazado'}`}>
                        {r?.estado ?? ''}
                      </span>
                    </td>                                            
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            !cargando && !error && haConsultado && (
              <div style={{ fontFamily: 'Inter', fontSize: '1.8vh', padding: '1vh', color: colors.secondaryButton }}>
                No hay pagos en este rango de fechas.
              </div>
            )
          )}
        </div>

        {/* Mensaje de error */}
        {error && (
          <div style={{
            marginTop: '2vh',
            color: colors.errorText,
            fontSize: '1.6vh',
            fontFamily: 'Inter'
          }}>
            {error}
          </div>
        )}

        <div style={{ textAlign: 'right', marginTop: '2vh' }}>
          <Boton 
            label="Descargar Excel" 
            onClick={descargarExcel} 
            disabled={!recibos.length} 
            color={colors.primary} 
            ancho="25vh" 
            alto="5vh" 
          />
        </div>
      </div>
    </div>
  );
}

export default RPagos;
